module.exports = __webpack_public_path__ + "static/media/modalprofile.52d3a7a9.svg";